import { Component, Convention } from '../../../concepts/objects';

export const Audited = new Convention<Audited>('Audited');

export interface Audited extends Component {

    userId: string;

    created: Date;
}
